import { OnInit, Component, Inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Misc } from "src/app/components/util/misc";
import { ParceiroEstimativa } from "src/app/models/estimativa-parceiro.model";
import { EstimativaParceiroService } from "src/app/services/estimativa-parceiro.service";

@Component({
    selector: "app-editar-parceiro-estimativa",
    templateUrl: "./editar-parceiro-estimativa.component.html",
    styleUrls: ["./editar-parceiro-estimativa.component.scss"],
})
export class EditarParceiroEstimativaDialogComponent implements OnInit {
    public basicFormModal: UntypedFormGroup;

    constructor(
        public dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private estimativaParceiroService: EstimativaParceiroService,
        public misc: Misc
    ) { }

    ngOnInit() {
        this.createEditForm(this.data);
    }

    createEditForm(parceiroEstimativa: any) {
        this.basicFormModal = this.fb.group({
            solucao: [parceiroEstimativa.solucao, Validators.required],
            quantidade: [parceiroEstimativa.quantidade, Validators.required],
            valor: [parceiroEstimativa.valor, Validators.required],
            administrativo: [parceiroEstimativa.pAdministrativo, Validators.required],
            comissao: [parceiroEstimativa.pComissao, Validators.required],
            impostos: [parceiroEstimativa.pImposto, Validators.required],
            investimento: [parceiroEstimativa.pInvestimento, Validators.required],
            margemLiquida: [parceiroEstimativa.pMargemLiquida, Validators.required],
        });
    }

    close(): void {
        this.dialogRef.close();
    }

    save() {
        const parceiroEstimativa = new ParceiroEstimativa();
        parceiroEstimativa.id = this.data.id;
        parceiroEstimativa.estimativaId = this.data.estimativaId;
        parceiroEstimativa.solucao = this.basicFormModal.value.solucao;
        parceiroEstimativa.quantidade = this.basicFormModal.value.quantidade;
        parceiroEstimativa.valor = this.basicFormModal.value.valor;
        parceiroEstimativa.pAdministrativo = this.basicFormModal.value.administrativo;
        parceiroEstimativa.pComissao = this.basicFormModal.value.comissao;
        parceiroEstimativa.pImposto = this.basicFormModal.value.impostos;
        parceiroEstimativa.pInvestimento = this.basicFormModal.value.investimento;
        parceiroEstimativa.pMargemLiquida = this.basicFormModal.value.margemLiquida;

        this.atualizarParceiroEstimativa(parceiroEstimativa);
    }

    atualizarParceiroEstimativa(parceiroEstimativa: ParceiroEstimativa) {
        this.estimativaParceiroService.atualizaEstimativaParceiro(parceiroEstimativa).subscribe({
            next: (result) => {
                this.misc.mensagemSucesso('Parceiro da Estimativa atualizado com sucesso');
                this.dialogRef.close(result);
            },
            error: (error) => {
                this.misc.processError(error, 'Não foi possível atualizar o Parceiro da Estimativa');
            }
        }).add(() => {
        });
    }
}
